import { sva } from '@allenai/varnish-panda-runtime/css';

import type { RecipeVariantProps } from '@allenai/varnish-panda-runtime/types';

const footerRecipe = sva({
    slots: ['root', 'linksGroup', 'copyRight'],
    base: {
        root: {
            display: 'flex',
            width: '[100%]',
            padding: '[16px]',
            color: 'text',
        },
        linksGroup: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: '[16px]',
            lg: {
                gridTemplateColumns: '[repeat(4, 1fr)]',
                justifyContent: 'space-between',
                gap: '[16px]',
            },
            md: {
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: '[16px]',
            },
            // I'd like to move these to either components with props
            // or using slots/custom classNames
            // which ever makes sense for the situation
            '& ul': {
                padding: '0',
                margin: '0',
                listStyleType: 'none',
            },
            '& a': {
                color: 'links',
                textDecoration: 'none',
            },
            '& label': {
                fontSize: '[20px]',
            },
        },
        copyRight: {
            display: 'flex',
            justifyContent: 'flex-start',
            flexWrap: 'wrap',
            gap: '[0px]',
            // I'd like to move these to either components with props
            // or using slots/custom classNames
            // which ever makes sense for the situation
            '& span': {
                marginRight: '[32px]',
            },
            '& ul': {
                display: 'flex',
                gap: '[32px]',
                padding: '0',
                '& li:first-child': {
                    listStyle: '[none]',
                },
            },
            '& li::marker': {
                color: 'background.opacity-10.reversed',
            },
        },
    },
    variants: {
        variant: {
            full: {
                root: {
                    flexDirection: 'column',
                    gap: '[16px]',
                },
            },
            slimLeft: {
                root: {
                    justifyContent: 'flex-start',
                },
                copyRight: {
                    display: 'flex',
                    alignItems: 'center',
                },
            },
            slimCenter: {
                root: {
                    justifyContent: 'center',
                },
                copyRight: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                },
            },
        },
        color: {
            default: {
                root: {
                    backgroundColor: 'background.opacity-100',
                },
            },
            filled: {
                root: {
                    backgroundColor: 'background.opacity-10.reversed',
                },
            },
        },
    },
    defaultVariants: {
        color: 'default',
        variant: 'full',
    },
});

type FooterRecipeProps = RecipeVariantProps<typeof footerRecipe>;

export { footerRecipe, footerRecipe as default };
export type { FooterRecipeProps };
